module.exports = __webpack_public_path__ + "e1ebf88465cc688a152a80890a236445.svg";


//////////////////
// WEBPACK FOOTER
// ./demo/img/Instagram_20x20.svg
// module id = 286
// module chunks = 0